export default {
  title: 'This is a SAFE Tag!',
  subtitle: {
    isNotSosafeUser: 'Download our app to scan your SAFE Tag and start being protected by SOSAFE',
  },
  downloadApp: 'Download SOSAFE',
};
